export default {
  placement: 'DETAILS',
  chatInteractionId: 62862,
  tagMaropost: 'Details'
}
